<template>
  <div class="sole-good" @click="goDetail">
    <good-image
      :img-url="ssu.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      border-with-radius
      :type="'sole-good-remind'"
      :is-video="isVideo"
      :custom-style="customImagStyle"
      :left-upper-tag="leftUpperTag"
      :sku-img="skuImg"
      :bottom-tag="bottomTag"
    />
    <div class="info">
      <base-info
        :name="ssu.skuBase.skuName"
        :format-info="formatInfo"
        :custom-style="customStyle"
        show-name-format-info
        :introduce-tags="introduceTags"
        :sku-attr-tags="skuAttrTags"
        :price-recommend-tag="priceRecommendTag"
        :price-save-tag="priceSaveTag"
      />
      <good-price
        :ssu="ssu"
        :common-tracer-pamas="commonTracerPamas"
        :ssu-info="ssuInfo"
        :custom-style="{ root: { marginTop: '.04rem' } }"
        complex
        :show-original-price="showOriginalPrice"
        :custom-operator="customOperator"
        :show-discount-price="true"
        no-discount-stage
        show-ssu-fp-text
        show-green-card
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../newMixin'
export default {
  name: 'NewSoleGood',
  mixins: [mixin],
  data() {
    return {
      customOperator: {
        simple: false,
        showPromoteTip: true,
        type: 'normal'
      },
      customImagStyle: {
        with: '1.08rem',
        height: '1.08rem',
        goodImage: {
          overflow: 'hidden',
          'border-radius': '.16rem',
          position: 'relative',
          'z-index': 2
        }
      },
      customStyle: {
        name: {
          margin: 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sole-good {
  width: 100%;
  padding: 0.16rem 0.24rem 0.2rem 0.24rem;
  // overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  box-sizing: border-box;
  @include flex(row, space-between, flex-start, nowrap);
}

.info {
  position: relative;

  width: 0;

  margin-left: 8px;
  // overflow: hidden;

  flex: auto;

  .good-tag-wrap {
    margin-top: 0.08rem;
  }
}
</style>
